module.exports = __webpack_public_path__ + "static/media/point_icon_08.1f310f29.svg";